import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share'

interface ShareButtonsProps {
  link: string
}

const ShareButtons = ({ link }: ShareButtonsProps) => {
  return (
    <div className='flex gap-2'>
      <div>
        <EmailShareButton url={link} subject={link}>
          <EmailIcon size={20} round />
        </EmailShareButton>
      </div>
      <div>
        <FacebookShareButton url={link}>
          <FacebookIcon size={20} round />
        </FacebookShareButton>
      </div>
      <div>
        <TwitterShareButton url={link}>
          <XIcon size={20} round />
        </TwitterShareButton>
      </div>
      <div>
        <RedditShareButton url={link}>
          <RedditIcon size={20} round />
        </RedditShareButton>
      </div>
      <div>
        <WhatsappShareButton url={link}>
          <WhatsappIcon size={20} round />
        </WhatsappShareButton>
      </div>
    </div>
  )
}

export default ShareButtons
